import * as React from "react";
import * as routeNodeStyles from "./QuickJournalDuneRouteNodes.css";
import {
    routeNodePulseDurationsInSeconds,
    routeNodePulseDelaysInSeconds,
    routeNodes,
    routeNodeRestOpacities,
    routePaths,
} from "./QuickJournalDuneRouteFieldData";

export function QuickJournalDuneRouteField({
    isPaused,
}: {
    isPaused: boolean;
}) {
    const animationPlayState: React.CSSProperties["animationPlayState"] =
        isPaused ? "paused" : "running";

    return (
        <div
            aria-hidden="true"
            style={{
                position: "absolute",
                inset: 0,
                pointerEvents: "none",
            }}
        >
            <svg
                aria-hidden="true"
                viewBox="0 0 420 460"
                preserveAspectRatio="none"
                style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0.74,
                }}
            >
                <defs>
                    <linearGradient
                        id="quickJournalDuneRouteGold"
                        x1="0%"
                        x2="100%"
                        y1="0%"
                        y2="0%"
                    >
                        <stop
                            offset="0%"
                            stopColor="#a9682d"
                            stopOpacity="0.08"
                        />
                        <stop
                            offset="22%"
                            stopColor="#d08b3d"
                            stopOpacity="0.62"
                        />
                        <stop
                            offset="62%"
                            stopColor="#edac50"
                            stopOpacity="0.48"
                        />
                        <stop
                            offset="100%"
                            stopColor="#a9682d"
                            stopOpacity="0.08"
                        />
                    </linearGradient>
                    <radialGradient
                        id="quickJournalDuneAmbientLight"
                        cx="58%"
                        cy="34%"
                        r="68%"
                    >
                        <stop
                            offset="0%"
                            stopColor="#c87936"
                            stopOpacity="0.24"
                        />
                        <stop
                            offset="44%"
                            stopColor="#8a482d"
                            stopOpacity="0.1"
                        />
                        <stop
                            offset="100%"
                            stopColor="#211713"
                            stopOpacity="0"
                        />
                    </radialGradient>
                    <radialGradient
                        id="quickJournalDuneVignette"
                        cx="50%"
                        cy="44%"
                        r="72%"
                    >
                        <stop
                            offset="0%"
                            stopColor="#060403"
                            stopOpacity="0"
                        />
                        <stop
                            offset="58%"
                            stopColor="#060403"
                            stopOpacity="0.04"
                        />
                        <stop
                            offset="100%"
                            stopColor="#060403"
                            stopOpacity="0.38"
                        />
                    </radialGradient>
                </defs>
                <rect
                    width="420"
                    height="460"
                    fill="url(#quickJournalDuneAmbientLight)"
                />
                {routePaths.map(({ d, opacity, width }) => (
                    <path
                        key={d}
                        d={d}
                        fill="none"
                        stroke="url(#quickJournalDuneRouteGold)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeOpacity={opacity}
                        strokeWidth={width}
                        vectorEffect="non-scaling-stroke"
                    />
                ))}
                <rect
                    width="420"
                    height="460"
                    fill="url(#quickJournalDuneVignette)"
                />
            </svg>
            {routeNodes.map(({ cx, cy, radius }, index) => {
                const size = Math.max(4, radius * 3);

                return (
                    <span
                        key={cx + "-" + cy}
                        style={{
                            position: "absolute",
                            left: (cx / 420) * 100 + "%",
                            top: (cy / 460) * 100 + "%",
                            width: size + "px",
                            height: size + "px",
                            borderRadius: "50%",
                            background: "rgba(255, 210, 132, 0.9)",
                            boxShadow:
                                "0 0 4px 1px rgba(255, 185, 92, 0.64), 0 0 13px 5px rgba(231, 132, 54, 0.3), 0 0 28px 11px rgba(181, 82, 37, 0.14)",
                            mixBlendMode: "screen",
                            transform: "translate(-50%, -50%)",
                            animationDelay:
                                routeNodePulseDelaysInSeconds[index] + "s",
                            animationDuration:
                                routeNodePulseDurationsInSeconds[index] + "s",
                            animationPlayState,
                            "--quickJournalDuneRouteNodeRestOpacity":
                                routeNodeRestOpacities[index],
                        } as React.CSSProperties}
                        className={routeNodeStyles.routeNode}
                    />
                );
            })}
        </div>
    );
}
